import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function hideApproveFraudReviewDialog(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_APPROVE_FRAUD_REVIEW_DIALOG, { show: false });
}
